import React from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { RTU } from "../../types/RTU";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface PopupProps {
  producerName: string;
  rtus: RTU[];
  onClose: () => void;
}

const PopupProducerDevices: React.FC<PopupProps> = ({ producerName, rtus, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const openRtuDetail = (event: any) => {
    const rtuId = event.data.id;
    const rtu = rtus.find((r) => r.id === rtuId);
    navigate(`/rtupage/${rtuId}`, { state: { rtu } });
  };

  return (
      <Dialog
        header={`Devices — ${producerName}`}
        visible
        modal
        className="dashboard-status-detail-dialog"
        style={{ width: "min(64rem, calc(100vw - 7rem))", maxWidth: "96vw" }}
        contentStyle={{ padding: "0.75rem 1rem 1rem" }}
        headerStyle={{ padding: "0.75rem 1rem", borderBottom: "1px solid #e9ecef" }}
        onHide={onClose}
        blockScroll
      >
        <DataTable
          value={rtus}
          onRowClick={openRtuDetail}
          rowClassName={() => "dashboard-status-detail-dialog__row"}
          scrollHeight="360px"
          scrollable
          showGridlines
          size="small"
          stripedRows
          tableStyle={{ width: "100%", tableLayout: "fixed" }}
        >
          <Column
            field="id"
            header={t("dashboard.tables.columns.wellId", { defaultValue: "Well ID" })}
            style={{ width: "7rem" }}
            bodyStyle={{ textAlign: "center" }}
          />
          <Column
            field="name"
            header={t("dashboard.tables.columns.rtuId", { defaultValue: "RTU ID" })}
            style={{ width: "25%" }}
          />
          <Column
            field="configVersion"
            header="Config Version"
            style={{ width: "32%" }}
          />
          <Column
            field="deploymentVersion"
            header="Deployment Version"
            style={{ width: "32%" }}
          />
        </DataTable>
      </Dialog>
  );
};

export default PopupProducerDevices;
